import { transitionPersonalPensionPlanBeneficiariesForm } from '../../../actions/personalPensionPlan/beneficiaries';
import {
    getBeneficiariesForms,
    getSelectedBeneficiariesFormIndex,
} from '../../../selectors/personalPensionPlan/beneficiaries';

import { FIELD_STATUS } from '../../../reducers/status';

export const beneficiariesFormRules = (store, next, action) => {
    const result = next(action);
    const beneficiariesForms = getBeneficiariesForms(store.getState());

    const selectedBeneficiariesFormIndex = getSelectedBeneficiariesFormIndex(store.getState());

    let beneficiariesFormValid = true;

    if (selectedBeneficiariesFormIndex !== null) {
        beneficiariesFormValid = validateBeneficiaryFormDetails(beneficiariesForms[selectedBeneficiariesFormIndex]);
    }

    const formAction = beneficiariesFormValid
        ? transitionPersonalPensionPlanBeneficiariesForm.formValid(selectedBeneficiariesFormIndex)
        : transitionPersonalPensionPlanBeneficiariesForm.formInvalid(selectedBeneficiariesFormIndex);
    store.dispatch(formAction);
    return result;
};

const validateBeneficiaryFormDetails = (formFields) => {
    return (
        formFields &&
        formFields.firstName &&
        formFields.firstName.status === FIELD_STATUS.VALID &&
        formFields.lastName &&
        formFields.lastName.status === FIELD_STATUS.VALID &&
        formFields.relationship &&
        formFields.relationship.status === FIELD_STATUS.VALID &&
        formFields.location &&
        formFields.location.status === FIELD_STATUS.VALID &&
        formFields.phoneNumber &&
        formFields.phoneNumber.status === FIELD_STATUS.VALID
    );
};
